import Immutable from "immutable";

import { getHostname } from "utils/location";

const hostToLang = Immutable.fromJS({
    com: "en",
    au: "en",
    jp: "ja",
    br: "pt",
    pt: "pt",
    es: "es",
    fr: "fr",
});

export const hostToLanguage = () => {
    const lastHostPart = Immutable.List(
        getHostname(window.location).split("."),
    ).last();
    return hostToLang.get(lastHostPart, "en");
};
